import './NotificationSettings.css';
export var overlayText = '_1cohdty0-3-5-0';